let isProd=true;
export const ASSETS = `/assets`;
// export const WEB_SERVICE = isProd ?(typeof window === "undefined" ?  "http://cookiesuit.gulenayva.com/data/":"/data/") : (typeof window === "undefined" ?  "http://cookiesuit.gulenayva.com/data/":"http://localhost:3000/data/");
export const WEB_SERVICE = isProd ?(typeof window === "undefined" ?  "https://cookiesuit.com/data/":"/data/") : (typeof window === "undefined" ?  "https://cookiesuit.com/data/":"http://localhost:3000/data/");


export const API_URL = isProd === true ? (typeof window !== "undefined" ? "/back/" : "http://localhost:5001/") : "http://localhost:5000/";
